// extracted by mini-css-extract-plugin
export default {"container":"NRY6Jw","header":"x3BCZx","scrollable":"aWZTIa","disableScroll":"YtFG7n","content":"C7Fi9L","isAnimated":"jnUgQL"};